import React from 'react';
import { Outlet, Link } from 'react-router-dom';
import { AppBar, Toolbar, Typography, Box, Button } from '@mui/material';

export default function Layout() {
  return (
    <>
      {/* Navbar */}
      <AppBar position="static" sx={{ backgroundColor: '#003366' }}>
        <Toolbar sx={{ display: 'flex', justifyContent: 'space-between' }}>
          <Typography variant="h6" component={Link} to="/" sx={{ textDecoration: 'none', color: '#fff' }}>
            Study To Innovate
          </Typography>
          <Box>
            <Button color="inherit" component={Link} to="/about">About</Button>
            <Button color="inherit" component={Link} to="/contact">Contact</Button>
            <Button color="inherit" component={Link} to="/login">Login</Button>
          </Box>
        </Toolbar>
      </AppBar>

      {/* Page Content */}
      <Box sx={{ minHeight: '80vh', p: 3 }}>
        <Outlet />
      </Box>

      {/* Footer */}
      <Box sx={{ backgroundColor: '#003366', color: 'white', textAlign: 'center', p: 2 }}>
        <Typography variant="body2">© {new Date().getFullYear()} Study To Innovate. All rights reserved.</Typography>
      </Box>
    </>
  );
}
